/**
 * Define the fraction of the currency as per param
 * @param minimumFractionDigits number default to 2
 * @param maximumFractionDigits number default to 2
 * @returns Intl.NumberFormat
 */
export const currencyFormatterFactory = (
  options?: Intl.NumberFormatOptions,
): Intl.NumberFormat => {
  const { minimumFractionDigits = 2, maximumFractionDigits = 2 } =
    options || {};
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

export const currencyFormatter = currencyFormatterFactory();

export const currencyFormatterNoDecimal = currencyFormatterFactory({
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
